"use strict";

const watermarkHelper = require("./watermarkHelper");

module.exports = ["$uibModal", "form", "Department", "$translate", "activeTab", "$state", "$scope", "Upload", "$stateParams", "reportConfig", "toast", "BuilderDataService",
  "departmentReportConfig", "dialog", "$timeout",
  function ($uibModal, form, Department, $translate, activeTab, $state, $scope, Upload, $stateParams, reportConfig, toast, BuilderDataService, departmentReportConfig, dialog, $timeout) {
    var _this = this;
    this.form = form;
    if (typeof _this.form.withoutRevision !== 'boolean') {
      _this.form.withoutRevision = false;
    }
    Department.graphs({
      id: $stateParams.departmentId
    })
      .$promise.then(function (graphs) {
        _this.graphs = graphs;
      });
    this.chipLoading = true;

    this.apiURL = require("../../server").server;
    this.departmentReportConfig = departmentReportConfig;
    this.activeTab = activeTab || 0;
    this.ownersAndSupervisors = [];
    this.departmentTags = [];
    this.usersTagsList = [];
    this.getUsersTagsInit = function () {
      _this.chipLoading = true;
      Department.find({
        filter:
        {
          "where": {
            "id": $state.params.departmentId
          },
          "include": ["owners", "tags"]
        }
      })
        .$promise.then(function (data) {
          const cleanData = JSON.parse(JSON.stringify(data));
          // console.log('cleanData', cleanData)
          _this.ownersAndSupervisors = cleanData[0]?.owners?.sort(function (a, b) {
            const lastNameComparison = a.lastName.localeCompare(b.lastName);
            if (lastNameComparison === 0) {
              return a.firstName.localeCompare(b.firstName);
            }
            return lastNameComparison;
          });

          _this.departmentTags = cleanData[0]?.tags?.sort(function (a, b) {
            return a.name.localeCompare(b.name);
          });
          _this.usersTagsList = _this.ownersAndSupervisors.concat(_this.departmentTags);

            $timeout(() => {
                _this.chipLoading = false;
            }, 100)
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    this.getUsersTagsInit();

    _this.ownersListToAdd = [].concat(_this.form.validate_users || []);
    _this.ownersListToAddInstance = [];
    if (_this.form.validate_defined?.length) {
      _this.form.validate_defined.forEach((instance, $index) => {
        _this.ownersListToAddInstance[$index] = [].concat(instance.validate_users || []);
      })
    }

    this.onValidateInstancesChange = function () {
      if (_this.form.validate_type !== 'instance-defined') {
        _this.form.validate_notify = _this.form.validate_notify ? _this.form.validate_notify : false;
        _this.form.validate_defined = [];
        _this.ownersListToAddInstance = []; // Reiniciar el array si `validate_instances` es 1
      } else if (_this.form.validate_type === 'instance-defined') {
        _this.form.validate_users = [];
        _this.ownersListToAdd = [];

        if (!_this.form.validate_defined) {
          _this.form.validate_defined = [];
          _this.ownersListToAddInstance = [];
        }

        $timeout(() => {
            while (_this.form.validate_defined.length < _this.form.validate_instances) {
              _this.form.validate_defined.push({
                input: '',
                field: '',
                validate_notify: false,
                validate_teamleader: false,
                validate_users: [],
                validate_tagsMask: [],
                validate_tagsMask_ExpandUser: false,
              });
            }
            if (_this.form.validate_instances < _this.form.validate_defined.length) {
              _this.form.validate_defined.splice(_this.form.validate_instances);
            }
            _this.form.validate_defined.forEach((instance, $index) => {
              _this.ownersListToAddInstance[$index] = [].concat(instance.validate_users || []);
            });
        }, 100)
      }
    };

    // For initialization
    this.onValidateInstancesChange();

    this.getFlattenedInputElements = function (form) {
      const processPages = function (pages, formType) {
        let flattenedElements = [];

        pages.forEach((page, pageIndex) => {
          const elementsWithLevels = _this.getElementsWithLevels(page.fields, pageIndex, 1, formType);
          flattenedElements = flattenedElements.concat(elementsWithLevels);
        });

        return flattenedElements;
      };

      let flattenedPages = processPages(form.pages, "Formulario");
      // return flattenedPages;

      return flattenedPages.filter(function (element) {
        // if ((!["simplelist", "qr", "select", "docs"].includes(element.type)) && element.id === _this.element.id) {
        //     return false;
        // }
        switch (element.type) {
          case 'text':
          // case 'sendemail':
          // case 'number':
          case 'select':
          case 'multiple':
          case 'formula':
            // case 'simplelist':
            // case 'group':
            // case 'sign':
            // case 'qr':
            // case 'docs':
            // case 'date':
            // case 'time':
            // case 'duration':                
            // case 'geo':
            // case 'page':
            return true;
          default:
            return false;
        }
      })
    };
    this.getElementsWithLevels = function (fields, pageIndex, level, formType) {
      return fields.flatMap(function (field) {
        if (field.type === 'simplelist') {
          const currentField = {
            ...field,
            level: level,
            disabled: false,
            form: formType,
            page: `Página ${pageIndex + 1}`
          };
          // NO SE PROCESAN LOS ELEMENTOS DENTRO DE SIMPLELIST
          // Procesar los nodos dentro del 'simplelist' después de 'simplelist'
          // const nodesProcessed = _this.getElementsWithLevels(field.nodes, pageIndex, level + 1, formType);
          return [currentField];
        }
        if (field.type === 'group') {
          const currentField = {
            ...field,
            level: level,
            disabled: false,
            form: formType,
            page: `Página ${pageIndex + 1}`
          };
          // Procesar los nodos dentro de 'group' despues de 'group'
          const nodesProcessed = _this.getElementsWithLevels(field.nodes, pageIndex, level + 1, formType);
          return [currentField].concat(nodesProcessed);
        }
        return [{ ...field, level: level, disabled: false, form: formType, page: `Página ${pageIndex + 1}` }];
      });
    };

    this.inputElementsForForm = this.getFlattenedInputElements(this.form);


    _this.getOwnersList = () => {
      return new Promise((resolve, reject) => { resolve(_this.ownersAndSupervisors) });
    }

    _this.getOwnersTagsList = () => {
      return new Promise((resolve, reject) => {
        resolve(_this.ownersAndSupervisors.concat(_this.departmentTags))
      });
    };

    this.reloadUsers = function () {
      _this.getUsersTagsInit();
    };

    this.selectedInField = [
      { id: 1, name: "Usuario" },
      { id: 2, name: "Supervisor" },
      { id: 3, name: "Dueño" },
    ]

    /*REPORTES EMAILS*/
    BuilderDataService.setForm(this.form);
    this.schemaOptions = ["schema1", "schema2", "custom"];
    this.array = [
      { value: "schema1", text: $translate.instant("DASHBOARD.DASH_FORM.REPORT.FORMAT_RPT_O1") },
      { value: "schema2", text: $translate.instant("DASHBOARD.DASH_FORM.REPORT.FORMAT_RPT_O2") },
      { value: "custom", text: $translate.instant("DASHBOARD.DASH_FORM.REPORT.FORMAT_RPT_O3") },
    ];

    this.photosPerRow = [
      { value: 1, text: "1" },
      { value: 2, text: "2" },
      { value: 3, text: "3" },
      { value: 4, text: "4" },
    ];

    this.optGrid = [
      { value: "grid-of-1", text: "1" },
      { value: "grid-of-2", text: "2" },
      { value: "grid-of-3", text: "3" },
      { value: "grid-of-4", text: "4" },
      { value: "grid-of-5", text: "5" },
      { value: "grid-of-6", text: "6" },
      { value: "grid-of-7", text: "7" },

    ];

    this.maxHeightPhotoInForm = [
      { value: "2.5", text: "2.5" },
      { value: "5", text: "5" },
      { value: "7.5", text: "7.5" },
      { value: "10", text: "10" },
    ];

    this.optInterline = [
      { value: "interline1px", text: "1" },
      { value: "interline3px", text: "3" },
      { value: "interline5px", text: "5" },
      { value: "interline10px", text: "10" },
    ];

    this.fontSize = [
      { value: "sm", text: $translate.instant("DASHBOARD.DASH_FORM.REPORT.FONT_SIZE_O1") },
      { value: "md", text: $translate.instant("DASHBOARD.DASH_FORM.REPORT.FONT_SIZE_O2") },
      { value: "lg", text: $translate.instant("DASHBOARD.DASH_FORM.REPORT.FONT_SIZE_O3") },
    ];

    this.pageSizes = [
      { value: "A4", text: "A4" },
      { value: "A5", text: "A5" },
      { value: "A3", text: "A3" },
      { value: "legal", text: "Legal" },
      { value: "letter", text: $translate.instant("DASHBOARD.DASH_FORM.REPORT.PAGE_SIZE_LETTER") },
    ];

    this.pageOrientations = [
      { value: "portrait", text: $translate.instant("DASHBOARD.DASH_FORM.REPORT.PAGE_ORIENTATION_2") },
      { value: "landscape", text: $translate.instant("DASHBOARD.DASH_FORM.REPORT.PAGE_ORIENTATION_1") },
    ];

    // console.log('ReportConfig 3', reportConfig)
    if (reportConfig) {
      // console.log('reportConfig 3.1 en if')
      this.reportConfig = reportConfig;
      if (this.reportConfig.validate == undefined) { //para compatibilidad hacia reportes cuando no existia el seteo
        this.reportConfig.validate = true;
        this.reportConfig.validate_title = true;
        this.reportConfig.validate_state = true;
        this.reportConfig.validate_fields = false;
      }
    } else {
      const reportConfig = BuilderDataService.getReportConfigInit();
      // console.log('ReportConfig 3.1 en else', reportConfig);
      return reportConfig;
    }

    this.reportConfig.interline = this.reportConfig.interline || "interline1px";
    this.reportConfig.maxHeightPhotoInForm = this.reportConfig.maxHeightPhotoInForm || "5";
    this.reportConfig.gridOf = this.reportConfig.gridOf || "grid-of-1";
    this.reportConfig.customFooter = this.reportConfig.customFooter || " ";
    this.reportConfig.customHeader = this.reportConfig.customHeader || " ";
    this.reportConfig.pageOrientation = this.reportConfig.pageOrientation || "portrait";
    this.reportConfig.pageSize = this.reportConfig.pageSize || "A4";


    if (!this.reportConfig.reportSchema) {
      this.reportConfig.reportSchema = "custom";
    }

    if (!this.reportConfig.fontSize) {
      this.reportConfig.fontSize = "md";
    }

    if (this.reportConfig.logo && this.reportConfig.logo !== "false") {
      this.reportLogo = this.reportConfig.logo;
    } else {
        this.reportLogo = undefined;
    }
    // MAXIMO PERMITIDO 4
    if (!this.reportConfig.photosPerRow || this.reportConfig.photosPerRow > 4) {
      this.reportConfig.photosPerRow = 4;
    }

    watermarkHelper.ensure(this.reportConfig);
    this.showWatermarkPanel = false;
    this.showLogoPanel = false;

    this.closeAssetPanels = () => {
      _this.showWatermarkPanel = false;
      _this.showLogoPanel = false;
    };

    this.openLogoPanel = ($event) => {
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
      _this.showIconPanel = false;
      _this.showWatermarkPanel = false;
      _this.showLogoPanel = true;
    };

    this.closeLogoPanel = () => {
      _this.showLogoPanel = false;
    };

    this.openWatermarkPanel = ($event) => {
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
      _this.showIconPanel = false;
      _this.showLogoPanel = false;
      _this.showWatermarkPanel = true;
    };

    this.closeWatermarkPanel = () => {
      _this.showWatermarkPanel = false;
    };

    this.updateWatermarkHtml = () => {
      watermarkHelper.updateHtml(_this.reportConfig, _this.apiURL);
    };

    this.setWatermarkPosition = (position) => {
      _this.reportConfig.watermark.position = position;
      _this.updateWatermarkHtml();
    };

    this.clearWatermarkImage = () => {
      _this.reportConfig.watermark.url = null;
      _this.updateWatermarkHtml();
    };

    this.watermarkPreviewSrc = () => {
      return watermarkHelper.getSrc(_this.reportConfig.watermark.url, _this.apiURL);
    };

    this.watermarkPreviewStyle = () => {
      return watermarkHelper.getImageStyle(_this.reportConfig.watermark);
    };

    this.getLogoUrl = () => {
      if (!_this.reportLogo) {
        return "";
      }
      return (_this.apiURL.replace("/api", "") || "") + _this.reportLogo;
    };

    watermarkHelper.bindThumbStatus(_this, $scope, $timeout);

    this.copyLogoUrl = ($event) => {
      if ($event) {
        $event.preventDefault();
      }
      const url = _this.getLogoUrl();
      if (!url) {
        return;
      }
      const showCopied = () => {
        toast.success($translate.instant("DASHBOARD.DASH_FORM.REPORT.URL_COPIED"));
      };
      const showError = () => {
        toast.error($translate.instant("DASHBOARD.DASH_FORM.REPORT.URL_COPY_ERROR"));
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => {
          $timeout(showCopied);
        }).catch(() => {
          $timeout(showError);
        });
        return;
      }
      try {
        const input = document.createElement("textarea");
        input.value = url;
        input.setAttribute("readonly", "");
        input.style.position = "absolute";
        input.style.left = "-9999px";
        document.body.appendChild(input);
        input.select();
        const ok = document.execCommand("copy");
        document.body.removeChild(input);
        if (ok) {
          showCopied();
        } else {
          showError();
        }
      } catch (e) {
        showError();
      }
    };

    $scope.uploadWatermarkFile = function (file) {
      if (!file) {
        return;
      }

      _this.markWatermarkThumbLoading();

      var unique = Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
      unique += Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);

      var ext = file.name.slice(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );
      var apiURL = require("../../server").server;
      file.upload = Upload.upload({
        url: apiURL + "/containers/" + _this.form.tenantId + "/upload",
        data: { file: file },
        picFile: Upload.rename(file, unique + "." + ext),
      });

      file.upload.then(function (response) {
        toast.success(
          $translate.instant("DASHBOARD.DASH_FORM.REPORT.LBL_LOGO_OK")
        );
        _this.reportConfig.watermark.url =
          "/api/containers/" +
          response.data.result.files.file[0].container +
          "/download/" +
          response.data.result.files.file[0].name;
        _this.updateWatermarkHtml();
      }, function () {
        _this.watermarkThumbStatus = "error";
      });
    };

    this.applyDeptTemplate = function () {
      if (_this.departmentReportConfig) {
        dialog.confirm({
          // title: "Reporte: Plantilla",
          title: $translate.instant('DASHBOARD.DASH_FORM.REPORT.DEPT_REPORT_DIALOG.TITLE'),
          // body: "Se reemplazará la configuración actual con la configuración de plantilla del departamento",
          body: $translate.instant('DASHBOARD.DASH_FORM.REPORT.DEPT_REPORT_DIALOG.BODY'),
          accept: $translate.instant('DASHBOARD.ACCEPT'),
          cancel: $translate.instant('DASHBOARD.CANCEL'),
          size: 'sm'
        }).then(() => {
          let reportConfigToReplace = JSON.parse(JSON.stringify(_this.departmentReportConfig));
          reportConfigToReplace.id = _this.reportConfig.id;
          reportConfigToReplace.formId = _this.reportConfig.formId
          _this.reportConfig = reportConfigToReplace;

          _this.reportConfig.customHeader = reportConfigToReplace.customHeader;
          _this.reportConfig.customFooter = reportConfigToReplace.customFooter;

          _this.reportConfig.interline = _this.reportConfig.interline || "interline1px";
          _this.reportConfig.maxHeightPhotoInForm = _this.reportConfig.maxHeightPhotoInForm || "5";
          _this.reportConfig.gridOf = _this.reportConfig.gridOf || "grid-of-1";

          // Table data load:
          if (this.reportConfig.tableLayout) {
            _this.reportConfig.tableLayout = false;
            _this.reportConfig.customFooter = reportConfigToReplace.customFooter || " ";
            _this.reportConfig.customHeader = reportConfigToReplace.customHeader || " ";
            $timeout(() => {
              _this.reportConfig.tableLayout = true;
            }, 100);
          }

          _this.reportConfig.pageOrientation = _this.reportConfig.pageOrientation || "portrait";
          _this.reportConfig.pageSize = _this.reportConfig.pageSize || "A4";

          if (!_this.reportConfig.reportSchema) {
            _this.reportConfig.reportSchema = "custom";
          }
          if (!_this.reportConfig.fontSize) {
            _this.reportConfig.fontSize = "md";
          }
          if (_this.reportConfig.logo) {
            _this.reportLogo = _this.reportConfig.logo;
          }
          // MAXIMO PERMITIDO 4
          if (!_this.reportConfig.photosPerRow || _this.reportConfig.photosPerRow > 4) {
            _this.reportConfig.photosPerRow = 4;
          }
          watermarkHelper.ensure(_this.reportConfig);
          _this.updateWatermarkHtml();
        })
      }
    }
     this.uploadFiles = function (file, errFile, destino) {
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          $timeout(() => {
            _this.form[destino] = reader.result;
          });
        };
        reader.readAsDataURL(file);
      }
    };

    this.showFieldsOnReport = function () {
      $uibModal.open({
        animation: true,
        controller: [
          "$uibModalInstance",
          "$http",
          "$stateParams",
          "Department",
          "Form",
          "Authentication",
          "dialog",
          "$translate",
          function ($uibModalInstance, $http, $stateParams, Department, Form, Authentication, dialog, $translate) {
            var _this = this;

            this.currentUserIsAdmin = true; //Authentication.isAuthorized("admin"); // to show element level
            _this.elements = [];
            _this.elementsToSelect = [];
            _this.elementsToDisplay = [];
            _this.form = form;

            _this.fieldToDisplayOptions = {
              accept: function (sourceNodeScope, destNodesScope) {
                if (sourceNodeScope.sourceOnly === false) {
                  return true;
                }

                var accept = true;

                for (var el in destNodesScope.$modelValue) {
                  if (
                    sourceNodeScope.$modelValue.id ==
                    destNodesScope.$modelValue[el].id
                  ) {
                    accept = false;
                  }
                }

                if (accept) {
                  return true;
                }
                return false;
              },
            };
            function walkNodes(nodes, elements, elementsToSelect, elementsToDisplay, pageIndex, path = [], parentLabel = "") {
                for (let k = 0; k < nodes.length; k++) {
                    const node = JSON.parse(JSON.stringify(nodes[k]));
                    
                    const currentPath = [...path, k + 1]; // nivel jerárquico, empieza desde 1
                    const levelString = currentPath.join("."); // Generar el string del tipo "1.1.1"
                    node.level = `P${pageIndex + 1} - ${levelString}`; // Guardar la posición como "P2 - 1.1.1"
                    nodes[k].level = node.level;

                    node._docIndex = docOrderSeq++; // orden de documento, usado como desempate estable

                    if (node.name) node.name = parentLabel.concat(node.name);
                    node.label = parentLabel.concat(node.label || "");
                    // Solo auto-mostramos los campos de nivel superior en formularios sin
                    // configuracion previa de reporte. Si ya existe configuracion, los campos
                    // nuevos no se agregan automaticamente para no alterar el orden guardado.
                    if (
                        nodes[k].displayOnReport === true ||
                        (!hasExistingReportConfig && parentLabel === "" && typeof nodes[k].displayOnReport === "undefined")
                    ) {
                        elementsToDisplay.push(node);
                    }
                    elements.push(nodes[k]);
                    elementsToSelect.push(node);
                    if (node.type === "group") {
                        walkNodes(nodes[k].nodes, elements, elementsToSelect, elementsToDisplay, pageIndex, currentPath, (nodes[k].name || nodes[k].label || "").concat("--"));
                    }
                }
            }

            function hasReportConfig(nodes) {
                for (let k = 0; k < nodes.length; k++) {
                    const field = nodes[k];
                    if (field.displayOnReport === true || typeof field.orderOnReport === "number") {
                        return true;
                    }
                    if (field.type === "group" && field.nodes && hasReportConfig(field.nodes)) {
                        return true;
                    }
                }
                return false;
            }

            const copyPages = _this.form.pages;

            // Indice incremental de orden de documento (desempate estable del ordenamiento).
            let docOrderSeq = 0;
            // Detectamos si el formulario ya tiene una configuracion de reporte guardada para
            // decidir si auto-incluir o no los campos nuevos en "Campos a mostrar".
            let hasExistingReportConfig = copyPages.some(function (page) {
                return hasReportConfig(page.fields);
            });

            for (let i = 0; i < copyPages.length; i++) {
                walkNodes(copyPages[i].fields, _this.elements, _this.elementsToSelect, _this.elementsToDisplay, i);
            }

            // Orden robusto: los campos sin orden valido (null/undefined) van al final y se
            // desempata por el orden de documento. Esto evita que la lista se reordene al
            // agregar nuevos campos o al eliminar existentes, y previene el crash cuando la
            // lista queda vacia (ya no se accede a elementsToDisplay[0]).
            if (_this.elementsToDisplay.length) {
              _this.elementsToDisplay.sort(function (a, b) {
                var ao = (a.orderOnReport === null || a.orderOnReport === undefined) ? Number.MAX_SAFE_INTEGER : a.orderOnReport;
                var bo = (b.orderOnReport === null || b.orderOnReport === undefined) ? Number.MAX_SAFE_INTEGER : b.orderOnReport;
                if (ao !== bo) return ao - bo;
                return (a._docIndex || 0) - (b._docIndex || 0);
              });
            }

            // Pasa todos los campos de la columna izquierda a la derecha, sin duplicar
            // y respetando el orden de documento (mismo criterio de desempate que el sort).
            _this.doAddAllElements = function () {
              var displayed = {};
              for (var i = 0; i < _this.elementsToDisplay.length; i++) {
                displayed[_this.elementsToDisplay[i].id] = true;
              }
              for (var j = 0; j < _this.elementsToSelect.length; j++) {
                var src = _this.elementsToSelect[j];
                if (!displayed[src.id]) {
                  _this.elementsToDisplay.push(JSON.parse(JSON.stringify(src)));
                  displayed[src.id] = true;
                }
              }
              _this.elementsToDisplay.sort(function (a, b) {
                return (a._docIndex || 0) - (b._docIndex || 0);
              });
            }

            _this.addAllElements = function () {
              // Si ya hay campos en la columna derecha, se avisa que el orden personalizado
              // se va a reordenar según el orden del formulario antes de continuar.
              if (_this.elementsToDisplay.length) {
                dialog.confirm({
                  title: $translate.instant('DASHBOARD.DASH_FORM.REPORT.ADD_ALL_DIALOG.TITLE'),
                  body: $translate.instant('DASHBOARD.DASH_FORM.REPORT.ADD_ALL_DIALOG.BODY'),
                  accept: $translate.instant('DASHBOARD.ACCEPT'),
                  cancel: $translate.instant('DASHBOARD.CANCEL'),
                  size: 'md'
                }).then(function () {
                  _this.doAddAllElements();
                }, function () {
                  // Cancelado: no se hace nada.
                });
              } else {
                _this.doAddAllElements();
              }
            };

            // Vacia la columna derecha (mutando el array en sitio para que ui-tree lo refleje).
            _this.deleteAllElements = function () {
              _this.elementsToDisplay.length = 0;
            };

            _this.guardarCampos = function () {
              for (var el in _this.elements) {
                _this.elements[el].displayOnReport = false;
                _this.elements[el].orderOnReport = null;
              }

              for (var el in _this.elementsToDisplay) {
                for (var el2 in _this.elements) {
                  if (_this.elementsToDisplay[el].id == _this.elements[el2].id) {
                    _this.elements[el2].displayOnReport = true;
                    _this.elements[el2].orderOnReport = parseFloat(el);
                  }
                }
              }
              $uibModalInstance.close(_this.elements);
            };
          },
        ],
        templateUrl:
          "dashboard-builder/formConfig/dashboardShowFieldsModal.html",
        controllerAs: "modal",
        size: "xlg",
        windowClass: "dialog",
        bindToController: true,
      });
    };

    $scope.uploadFiles = function (file, errFile) {
      if (file) {
        _this.markLogoThumbLoading();
        _this.reportConfig.logo = file.name;

        var unique = Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
        unique += Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);

        var ext = file.name.slice(
          file.name.lastIndexOf(".") + 1,
          file.name.length
        );
        var apiURL = require("../../server").server;
        file.upload = Upload.upload({
          url: apiURL + "/containers/" + _this.form.tenantId + "/upload",
          data: { file: file },
          picFile: Upload.rename(file, unique + "." + ext),
          success: function (res) {
            console.log(res);
          },
        });

        file.upload.then(function (response) {
          toast.success(
            $translate.instant("DASHBOARD.DASH_FORM.REPORT.LBL_LOGO_OK")
          );
          _this.reportLogo =
            "/api/containers/" +
            response.data.result.files.file[0].container +
            "/download/" +
            response.data.result.files.file[0].name;
          _this.reportConfig.logo = _this.reportLogo;
        }, function () {
          _this.logoThumbStatus = "error";
        });
      }
    };

    _this.setColor = function(color) {
        _this.form.logoColor = color;
    };

    _this.pastelColors = [
        '#FFADAD', // Rojo pastel (Peligro)
        '#FFD6A5', // Naranja pastel (Advertencia)
        '#FDFFB6', // Amarillo pastel
        '#CAFFBF', // Verde pastel (Salud/Seguridad)
        '#9BF6FF', // Celeste pastel (Reportes)
        '#A0C4FF', // Azul pastel (Admin)
        '#BDB2FF', // Violeta pastel
        '#FFC6FF', // Rosa pastel
        '#555555'  // Gris oscuro (Neutro)
    ];

    _this.materialIcons = [
      // SEGURIDAD
      { id: 'alert-outline', label: 'Alerta de Peligro', category: 'Seguridad' },
      { id: 'alert-octagon-outline', label: 'Riesgo Crítico', category: 'Seguridad' },
      { id: 'fire-alert', label: 'Riesgo de Incendio', category: 'Seguridad' },
      { id: 'flash-outline', label: 'Riesgo Eléctrico', category: 'Seguridad' },
      { id: 'shield-alert-outline', label: 'Incidente Seguridad', category: 'Seguridad' },

      // SALUD
      { id: 'shield-check-outline', label: 'Salud y Seguridad', category: 'H&S' },
      { id: 'medical-bag', label: 'Servicios Médicos', category: 'H&S' },
      { id: 'hospital-marker', label: 'Primeros Auxilios', category: 'H&S' },
      { id: 'face-mask-outline', label: 'Protección Facial', category: 'H&S' },

      // REPORTES
      { id: 'clipboard-text-outline', label: 'Nueva Tarea/Checklist', category: 'Reportes' },
      { id: 'clipboard-check-outline', label: 'Tarea Completada', category: 'Reportes' },
      { id: 'chart-bar', label: 'Análisis de Datos', category: 'Reportes' },
      { id: 'file-document-edit-outline', label: 'Editar Reporte', category: 'Reportes' },
      { id: 'signature-freehand', label: 'Firma Digital', category: 'Reportes' },

      // OPERACIONES
      { id: 'package-variant-closed', label: 'Almacén/Stock', category: 'Operaciones' },
      { id: 'factory', label: 'Maquinaria/Fábrica', category: 'Operaciones' },
      { id: 'map-marker-outline', label: 'Ubicación', category: 'Operaciones' },
      { id: 'truck-outline', label: 'Logística', category: 'Operaciones' },
      { id: 'hard-hat', label: 'EPP/Casco', category: 'Operaciones' }
    ].concat([
      // SEGURIDAD PROLONGADA
      { id: 'eye-outline', label: 'Protección Ocular', category: 'Seguridad' },
      { id: 'ear-hearing-off', label: 'Protección Auditiva', category: 'Seguridad' },
      { id: 'biohazard', label: 'Riesgo Biológico', category: 'Seguridad' },
      { id: 'thermometer-alert', label: 'Riesgo Térmico', category: 'Seguridad' },
      
      // MANTENIMIENTO Y ALTURA
      { id: 'tools', label: 'Mantenimiento', category: 'Operaciones' },
      { id: 'ladder', label: 'Trabajo en Altura', category: 'Operaciones' },
      { id: 'crane', label: 'Cargas/Grúas', category: 'Operaciones' },
      { id: 'forklift', label: 'Montacargas', category: 'Operaciones' },
      { id: 'engine-outline', label: 'Falla de Motor', category: 'Operaciones' },

      // VEHÍCULOS Y LOGÍSTICA
      { id: 'car-emergency', label: 'Vehículo de Emergencia', category: 'Operaciones' },
      { id: 'gas-station-outline', label: 'Combustible', category: 'Operaciones' },
      { id: 'speedometer', label: 'Exceso de Velocidad', category: 'Operaciones' },

      // GESTIÓN HUMANA
      { id: 'bullhorn-outline', label: 'Comunicado/Aviso', category: 'Reportes' },
      { id: 'account-alert-outline', label: 'Falta de Personal', category: 'RRHH' },
      { id: 'account-clock-outline', label: 'Fatiga/Horarios', category: 'RRHH' },
      { id: 'handshake-outline', label: 'Acuerdo/Inducción', category: 'RRHH' },
      { id: 'brain', label: 'Factores Psicosociales', category: 'RRHH' }
    ]);

    _this.groupedIcons = _this.materialIcons.reduce(function(acc, icon) {
      acc[icon.category] = acc[icon.category] || [];
      acc[icon.category].push(icon);
      return acc;
    }, {});

    _this.isMaterialIcon = function(logo) {
      if (!logo) return false;
      if (typeof logo !== 'string') return false;
      if (logo.includes('data:image') || logo.includes('/api/')) return false;
      return _this.materialIcons.some(function(i) { return i.id === logo; }) || (!logo.includes('/') && !logo.includes('.'));
    };

    _this.selectPredefinedIcon = function(icon) {
      _this.form.logo = icon;
      if (!_this.form.logoColor) {
        _this.form.logoColor = '#555555';
      }
      _this.showIconPanel = false;
    };

    _this.loadEditorHTML = function (scroll) {
      // console.log('scroll', scroll ? 'true' : 'false');

      if (!_this.reportConfig.tableLayout) {
        _this.reportConfig.customHeader = ' ';
        _this.reportConfig.customFooter = ' ';
        return
      };


      $timeout(function () {

        if (!scroll) {
          $timeout(() => {
            // console.log('scrollDown')
            $scope.scrollDown();
          }, 150);
        }
      }, 100);
    };

    // Function to scrollDown
    $scope.scrollDown = function () {
      var container = document.getElementById('scrollContainer');
      container.scrollTop = container.scrollHeight;
    };

    angular.element(document).ready(_this.loadEditorHTML);

    this.reportConfig.reportEmails = this.reportConfig.reportEmails || [];

    if (!this.reportConfig.reportEmails) {
      this.emailDirections = [];
      this.reportConfig.reportEmails = [];
    }

    this.emailDirections = this.reportConfig.reportEmails.map((value) => value.toLowerCase())

    this.addEmails = () => {
      if (this.tempEmail && this.tempEmail.trim() !== '') {
        this.reportConfig.reportEmails.push(
          ...this.tempEmail.split(",").map((email) => email.trim().toLowerCase())
        );
        this.tempEmail = "";
      }
    };

    _this.openConfigEmails = function () {
      var options = {
        animation: true,
        controller: require("./dinamicEmail"),
        templateUrl: "dashboard-builder/formConfig/dinamicEmail.html",
        controllerAs: "ctrl",
        size: "xlg",
        windowClass: "dialog",
        bindToController: true,
        resolve: {
          reportConfig: function () {
            return _this.reportConfig;
          },
        },
      };

      $uibModal.open(options);
    };

    /*PARA VALIDACIONES*/
    this.elementsList = require("../dashboardBuilderElements")(
      $translate
    ).filter((el) =>
      [
        "checkbox",
        "multiple",
        "select",
        "text",
        "number",
        "simplelist",
        "formula",
        "group",
        "sign",
        "docs",
        "date",
        "time",
        "timestamp"
      ].includes(el.type)
    );

    this.form.validate_pages = this.form.validate_pages || [
      { id: "validate_fields", type: "page", fields: [], requires: [] },
    ];

    this.removeElement = function (id) {
      let bodyInfo = $translate.instant(
        "DASHBOARD.DASH_BUILDER.DIAG_DEL_ELEMENT.BODY"
      );
      if (_this.form.items && _this.form.items.length) {
        bodyInfo = $translate.instant(
          "DASHBOARD.DASH_BUILDER.DIAG_DEL_ELEMENT.BODYWITHDATA"
        );
      }
      dialog
        .confirm({
          title: $translate.instant(
            "DASHBOARD.DASH_BUILDER.DIAG_DEL_ELEMENT.TITLE"
          ),
          body: bodyInfo,
          accept: $translate.instant(
            "DASHBOARD.DASH_BUILDER.DIAG_DEL_ELEMENT.ACCEPT"
          ),
          cancel: $translate.instant("DASHBOARD.CANCEL"),
          size: "sm",
        })
        .then(function () {
          _this.removeElementVal(id);
        });
    };

    _this.removeElementVal = function (id) {
      function removeInnerArray(fields, id) {
        fields.forEach(function (element, index) {
          if (element.id == id) {
            fields.splice(index, 1);
          } else if (element.nodes && element.nodes.length > 0)
            removeInnerArray(element.nodes, id);

        });

      }
      removeInnerArray(_this.form.validate_pages[0].fields, id);
    },

      this.treeOptions = {
        accept: function A(sourceNodeScope, destNodesScope) {

          var depth = destNodesScope.depth();
          var sourceType = sourceNodeScope.$modelValue.type;

          //Max depth is page>element>subelement>subelement2 (there is subelement3 level)
          //At depth 0 can only drop pages
          if (depth == 0) {
            return sourceType === "page";
          }
          //At depth 1 can drop anything but pages (this is inside a page)
          else if (depth == 1) {
            return sourceType !== "page";
          }
          //At depth 2 it gets more complex
          else if (depth >= 2) {
            var destType = destNodesScope.$parent.ctrl.element.type;
            switch (sourceType) {
              //Can't drop pages
              case "page":
                return false;
              //we can drop groups or simplelists into anything but a group or list. (Isn't this the same as only inside page? Can we actually drop groups or simplelists at this depth?)
              case "group":
                return depth <= 3;
              case "simplelist":
                return destType == "group" && depth <= 3;
              //These can be droped inside group AND simplelist
              case "select":
              case "text":
              case "sendemail":
              case "number":
              case "date":
              case "time":
              case "qr":
              case "geo":
              case "formula":
              case "duration":
              case "checkbox":
              case "sign":
              case "multiple":
              case "video":
              case "photo":
                return (
                  destType === "group" || destType === "simplelist"
                );
              //All other elements can be droped inside group only
              default:
                return (
                  destType === "group" || destType === "simplelist"
                );
            }
          }
          return false;
        },
      };

    this.elementsOptions = {
      dropped: function (event) {
        event.source.cloneModel.id = Math.random().toString(36).substr(2, 9);
      },
    };

    this.onElementDoubleClick = function (element) {
      let clonedElement = JSON.parse(JSON.stringify(element));
      delete clonedElement.$$hashKey;
      clonedElement.id = Math.random().toString(36).substr(2, 9);
      _this.form.validate_pages[0].fields.push(clonedElement);
    }

    this.cloneElement = function (id) {
      let idMappings = {}; // Object to store the mappings of old and new IDs
      let mainClonedElement = null;

      function cloneInnerArray(fields, id) {
        fields.forEach(function (element, index) {
          if (element.id == id) {
            // Clone element
            let clonedElement = JSON.parse(JSON.stringify(element));
            updateElement(clonedElement);
            fields.splice(index + 1, 0, clonedElement);

            // Save the main cloned element
            mainClonedElement = fields[index + 1];
          }
          else if (element.nodes && element.nodes.length > 0) {
            cloneInnerArray(element.nodes, id);
          }
        });
      }

      function updateElement(element) {
        let oldId = element.id
        let newId = Math.random().toString(36).substr(2, 9);
        element.id = newId;
        idMappings[oldId] = newId; // Save old and new Id
        delete element.$$hashKey;
        if (element.nodes && Array.isArray(element.nodes)) {
          element.nodes.forEach(updateElement);
        }
      }

      // this.pages.forEach(function (page) {
      cloneInnerArray(_this.form.validate_pages[0].fields, id);
      // });

      function walkProperties(obj) {
        if (obj && typeof obj === "object") {
          Object.keys(obj).forEach(key => {
            if (typeof obj[key] === "string") {
              if (idMappings[obj[key]] !== undefined) {
                obj[key] = idMappings[obj[key]];
              }
            } else if (Array.isArray(obj[key])) {
              obj[key].forEach(el => {
                if (typeof el === "object") {
                  walkProperties(el);
                }
              });
            } else if (typeof obj[key] === "object") {
              walkProperties(obj[key]);
            }
          });
        }
      }

      // Replace old Id in clone elements
      if (mainClonedElement) {
        walkProperties(mainClonedElement);
      }
    }

    this.closeConfig = function () {

      let ownersListToAddMod = [];
      let ownersListToAddInstanceMod = [];

      if (_this.ownersListToAdd?.length > 0) {
        ownersListToAddMod = _this.ownersListToAdd.map(item => {
          return ({
            id: item.id,
          })
        })
      }

      if (_this.ownersListToAddInstance?.length > 0) {
        // console.log('entro a if 1')
        ownersListToAddInstanceMod = _this.ownersListToAddInstance.map((items) => {
          // console.log('items', items);
          return items.map(item => {
            return ({
              id: item.id,
            })
          })
        })
      }

      // console.log('ownersListToAddMod', ownersListToAddMod)
      // console.log('ownersListToAddInstanceMod', ownersListToAddInstanceMod)

      _this.updateWatermarkHtml();
      _this.$close({
        reportConfig: _this.reportConfig,
        ownersListToAdd: ownersListToAddMod,
        ownersListToAddInstance: ownersListToAddInstanceMod,
        validate_defined: _this.form.validate_defined,
        metadata: _this.form.metadata
      })
    }

  },
];
